import { render, staticRenderFns } from "./CompanyDetail.vue?vue&type=template&id=5d3f2de3&"
import script from "./CompanyDetail.vue?vue&type=script&lang=ts&"
export * from "./CompanyDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports